const state = {
    receivedRatings: [],
    addedRatings: []
};
const mutations = {
    SET_RECEIVED_RATINGS(state, receivedRatings) {
        state.receivedRatings = receivedRatings
    },
    SET_ADDED_RATINGS(state, addedRatings) {
        state.addedRatings = addedRatings
    },

};
const getters = {
    getReceivedRatings: (state) => {
        return state.receivedRatings
    },
    getAddedRatings: (state) => {
        return state.addedRatings
    },
};

export default {
    state,
    mutations,
    getters,
};